export default __webpack_public_path__ + "static/media/arrow-down-white-icon.33a0045c.svg";